export default [
    '$rootScope',
    'SPClientData',
    function themeDataFacade($rootScope, SPClientData) {
        $rootScope.themeData = SPClientData.getThemeData();
    }
];
